/**
 * useCalculatePayroll — mutation a bérszámfejtési futtatás kalkulálásához
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { calculate, type PayrollRunDto } from '../api/payroll-api';

export function useCalculatePayroll() {
  const queryClient = useQueryClient();

  return useMutation<PayrollRunDto, Error, string>({
    mutationFn: async (id: string) => {
      const res = await calculate(id);
      return res.data;
    },
    onSuccess: data => {
      void queryClient.invalidateQueries({ queryKey: ['payroll', 'runs'] });
      void queryClient.invalidateQueries({ queryKey: ['payroll', 'run', data.id] });
    },
  });
}
